import React from "react";

var urlImage = {
  textF1: require("../../images/banner/back_ground.png"),
  textF2: require("../../images/banner/back_ground.png"),
  textF3: require("../../images/banner/back_ground.png"),
  textI: require("../../images/banner/back_ground.png"),
  textV1: require("../../images/banner/back_ground.png"),
  textV2: require("../../images/banner/back_ground.png"),
  textE1: require("../../images/banner/back_ground.png"),
  textE2: require("../../images/banner/back_ground.png"),
  textE3: require("../../images/banner/back_ground.png"),
  textE4: require("../../images/banner/back_ground.png"),
};

class Projects1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { replaceImg: false };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ replaceImg: true });
    }, 3900);
  }
  render() {
    return (
      <div className="logo-center relative">
        <div
          dangerouslySetInnerHTML={{
            __html: logo1Animate,
          }}
          className="logofive1"
        />
        <div
          dangerouslySetInnerHTML={{
            __html: logo2NoAnimate,
          }}
          className="logofive2"
        />
      </div>
    );
  }
}
var logo1Animate = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
y="0px" width="500px" viewBox="0 0 325 120" enable-background="new 0 0 325 120" xml:space="preserve" style=""
height="200px">
<path fill="url('https://drive.google.com/uc?export=views&id=1ivxrc50AWQ59cjq5wOe0Sekkw3b6E5zR)" opacity="1.000000" stroke="none" d="
M87.000000,1.000000 
C90.361290,1.000000 93.722572,1.000000 97.541931,1.468657 
C98.000000,41.624878 98.000000,81.312439 98.000000,121.000000 
C74.312439,121.000000 50.624878,121.000000 26.468658,120.531342 
C26.000000,80.375122 26.000000,40.687561 26.000000,1.000000 
C37.354229,1.000000 48.708454,1.000000 60.531342,1.468654 
C61.000000,9.858344 61.000000,17.779381 61.000000,25.688736 
C69.969002,25.688736 78.351570,25.688736 87.000000,25.688736 
C87.000000,17.252964 87.000000,9.126482 87.000000,1.000000 
M66.612335,74.000000 
C73.343552,74.000000 80.074760,74.000000 86.655792,74.000000 
C86.655792,65.273834 86.655792,57.234253 86.655792,49.345581 
C77.935875,49.345581 69.563774,49.345581 61.172234,49.345581 
C61.172234,57.611473 61.172234,65.530579 61.172234,73.771645 
C62.762066,73.852905 64.200996,73.926453 66.612335,74.000000 
z" class="HNpDwPXc_0 svg-elem-1"></path>

<path fill="#FFFFFF" opacity="1.000000" stroke="none" d="
M231.000000,1.000000 
C234.361282,1.000000 237.722580,1.000000 241.541931,1.468657 
C242.000000,41.624878 242.000000,81.312439 242.000000,121.000000 
C230.645767,121.000000 219.291550,121.000000 207.364761,120.648254 
C206.410461,119.584373 205.957794,118.900864 205.657318,118.155952 
C196.157593,94.605423 186.616653,71.071281 177.205353,47.485420 
C171.038177,32.029678 165.061813,16.497789 159.000000,1.000002 
C174.354233,1.000000 189.708450,1.000000 205.531342,1.468654 
C206.000000,9.858178 206.000000,17.779049 206.000000,25.688488 
C214.635757,25.688488 222.685425,25.688488 231.000000,25.688488 
C231.000000,17.253065 231.000000,9.126533 231.000000,1.000000 
z" class="HNpDwPXc_1 svg-elem-2"></path>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" d="
M326.000000,74.000000 
C326.000000,81.354256 326.000000,88.708504 325.750061,96.542511 
C325.340393,97.070381 325.180664,97.118515 324.556030,97.094299 
C317.061066,97.070099 310.030975,97.118248 302.690613,97.173927 
C302.572693,97.825562 302.765106,98.469666 302.976013,99.574142 
C302.718536,106.695419 302.442596,113.356323 302.094482,120.257751 
C302.014862,120.665504 302.007416,120.832748 302.000000,121.000000 
C290.645782,121.000000 279.291534,121.000000 267.468658,120.531342 
C267.000000,80.375122 267.000000,40.687561 267.000000,1.000000 
C278.354218,1.000000 289.708466,1.000000 301.531342,1.468654 
C302.000000,9.864621 302.000000,17.791935 302.000000,26.000000 
C310.399811,26.000000 318.199890,26.000000 326.000000,26.000000 
C326.000000,33.354252 326.000000,40.708500 325.531342,48.531376 
C309.479584,49.000000 293.896454,49.000000 278.315033,49.000000 
C278.315033,57.633320 278.315033,65.687744 278.315033,74.000000 
C294.419098,74.000000 310.209534,74.000000 326.000000,74.000000 
z" class="HNpDwPXc_2 svg-elem-3"></path>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" d="
M123.000000,1.000000 
C126.361290,1.000000 129.722580,1.000000 133.542511,1.391032 
C134.009521,2.115044 133.923462,2.485865 134.039612,2.775631 
C144.462311,28.775736 154.946487,54.751308 165.318741,80.771500 
C170.647842,94.140327 175.779251,107.587975 181.000000,121.000000 
C161.979111,121.000000 142.958206,121.000000 123.468658,120.531342 
C123.000000,80.375122 123.000000,40.687561 123.000000,1.000000 
z" class="HNpDwPXc_3 svg-elem-4"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M181.468643,121.000000 
C175.779251,107.587975 170.647842,94.140327 165.318741,80.771500 
C154.946487,54.751308 144.462311,28.775736 134.039612,2.775631 
C133.923462,2.485865 134.009521,2.115044 134.000580,1.391032 
C142.020905,1.000000 150.041809,1.000000 158.531342,1.000002 
C165.061813,16.497789 171.038177,32.029678 177.205353,47.485420 
C186.616653,71.071281 196.157593,94.605423 205.657318,118.155952 
C205.957794,118.900864 206.410461,119.584373 206.896103,120.648254 
C198.645767,121.000000 190.291534,121.000000 181.468643,121.000000 
z" class="HNpDwPXc_4 svg-elem-5"></path>

<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M25.531321,1.000000 
C26.000000,40.687561 26.000000,80.375122 26.000000,120.531342 
C17.688169,121.000000 9.376340,121.000000 1.063393,120.999985 
C1.062276,80.999962 1.062276,40.999950 1.062276,1.000000 
C9.103914,1.000000 17.083279,1.000000 25.531321,1.000000 
z" class="HNpDwPXc_5 svg-elem-6"></path>

<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M266.531372,1.000000 
C267.000000,40.687561 267.000000,80.375122 267.000000,120.531342 
C258.979095,121.000000 250.958191,121.000000 242.468643,121.000000 
C242.000000,81.312439 242.000000,41.624878 242.000000,1.468657 
C250.020905,1.000000 258.041809,1.000000 266.531372,1.000000 
z" class="HNpDwPXc_6 svg-elem-7"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M122.531349,1.000000 
C123.000000,40.687561 123.000000,80.375122 123.000000,120.531342 
C114.979103,121.000000 106.958199,121.000000 98.468651,121.000000 
C98.000000,81.312439 98.000000,41.624878 98.000000,1.468657 
C106.020897,1.000000 114.041801,1.000000 122.531349,1.000000 
z" class="HNpDwPXc_7 svg-elem-8"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M326.000000,73.531349 
C310.209534,74.000000 294.419098,74.000000 278.315033,74.000000 
C278.315033,65.687744 278.315033,57.633320 278.315033,49.000000 
C293.896454,49.000000 309.479584,49.000000 325.531342,49.000000 
C326.000000,57.020901 326.000000,65.041801 326.000000,73.531349 
z" class="HNpDwPXc_8 svg-elem-9"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M86.531349,1.000000 
C87.000000,9.126482 87.000000,17.252964 87.000000,25.688736 
C78.351570,25.688736 69.969002,25.688736 61.000000,25.688736 
C61.000000,17.779381 61.000000,9.858344 61.000000,1.468654 
C69.354233,1.000000 77.708466,1.000000 86.531349,1.000000 
z" class="HNpDwPXc_9 svg-elem-10"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M230.531357,1.000000 
C231.000000,9.126533 231.000000,17.253065 231.000000,25.688488 
C222.685425,25.688488 214.635757,25.688488 206.000000,25.688488 
C206.000000,17.779049 206.000000,9.858178 206.000000,1.468654 
C214.020905,1.000000 222.041809,1.000000 230.531357,1.000000 
z" class="HNpDwPXc_10 svg-elem-11"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M326.000000,25.531321 
C318.199890,26.000000 310.399811,26.000000 302.000000,26.000000 
C302.000000,17.791935 302.000000,9.864621 302.000000,1.468654 
C309.927856,1.000000 317.855713,1.000000 326.000000,1.000000 
C326.000000,9.019587 326.000000,17.041115 326.000000,25.531321 
z" class="HNpDwPXc_11 svg-elem-12"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M303.000916,97.166397 
C310.030975,97.118248 317.061066,97.070099 324.671448,97.283447 
C325.454346,97.773598 325.703766,97.925285 326.000000,98.000000 
C326.000000,105.020950 326.000000,112.041893 325.780640,119.639328 
C325.287628,120.415283 325.100555,120.676674 325.000000,121.000000 
C317.979034,121.000000 310.958099,121.000000 303.383423,120.794968 
C302.670258,120.327766 302.449219,120.136864 302.166626,120.017227 
C302.442596,113.356323 302.718536,106.695419 302.990875,99.249649 
C302.991821,98.031990 302.996368,97.599190 303.000916,97.166397 
z" class="HNpDwPXc_12 svg-elem-13"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M326.000000,97.750000 
C325.703766,97.925285 325.454346,97.773598 325.136353,97.355804 
C325.180664,97.118515 325.340393,97.070381 325.750061,97.011124 
C326.000000,97.000000 326.000000,97.500000 326.000000,97.750000 
z" class="HNpDwPXc_13 svg-elem-14"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M302.094452,120.257751 
C302.449219,120.136864 302.670258,120.327766 302.914856,120.794968 
C303.000000,121.000000 302.500000,121.000000 302.250000,121.000000 
C302.007416,120.832748 302.014862,120.665504 302.094452,120.257751 
z" class="HNpDwPXc_14 svg-elem-15"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M325.500000,121.000000 
C325.100555,120.676674 325.287628,120.415283 325.780640,120.107910 
C326.000000,120.333336 326.000000,120.666664 325.500000,121.000000 
z" class="HNpDwPXc_15 svg-elem-16"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M66.126129,74.000000 
C64.200996,73.926453 62.762066,73.852905 61.172234,73.771645 
C61.172234,65.530579 61.172234,57.611473 61.172234,49.345581 
C69.563774,49.345581 77.935875,49.345581 86.655792,49.345581 
C86.655792,57.234253 86.655792,65.273834 86.655792,74.000000 
C80.074760,74.000000 73.343552,74.000000 66.126129,74.000000 
z" class="HNpDwPXc_16 svg-elem-17"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M302.690613,97.173927 
C302.996368,97.599190 302.991821,98.031990 302.972412,98.789276 
C302.765106,98.469666 302.572693,97.825562 302.690613,97.173927 
z" class="HNpDwPXc_17 svg-elem-18"></path>
<style data-made-with="vivus-instant">
    .HNpDwPXc_0 {
        stroke-dasharray: 531 533;
        stroke-dashoffset: 532;
        animation: HNpDwPXc_draw 448ms ease-in-out 0ms forwards;
    }

    .HNpDwPXc_1 {
        stroke-dasharray: 415 417;
        stroke-dashoffset: 416;
        animation: HNpDwPXc_draw 350ms ease-in-out 448ms forwards;
    }

    .HNpDwPXc_2 {
        stroke-dasharray: 450 452;
        stroke-dashoffset: 451;
        animation: HNpDwPXc_draw 380ms ease-in-out 799ms forwards;
    }

    .HNpDwPXc_3 {
        stroke-dasharray: 317 319;
        stroke-dashoffset: 318;
        animation: HNpDwPXc_draw 268ms ease-in-out 1180ms forwards;
    }

    .HNpDwPXc_4 {
        stroke-dasharray: 308 310;
        stroke-dashoffset: 309;
        animation: HNpDwPXc_draw 260ms ease-in-out 1448ms forwards;
    }

    .HNpDwPXc_5 {
        stroke-dasharray: 289 291;
        stroke-dashoffset: 290;
        animation: HNpDwPXc_draw 244ms ease-in-out 1709ms forwards;
    }

    .HNpDwPXc_6 {
        stroke-dasharray: 289 291;
        stroke-dashoffset: 290;
        animation: HNpDwPXc_draw 244ms ease-in-out 1953ms forwards;
    }

    .HNpDwPXc_7 {
        stroke-dasharray: 289 291;
        stroke-dashoffset: 290;
        animation: HNpDwPXc_draw 244ms ease-in-out 2198ms forwards;
    }

    .HNpDwPXc_8 {
        stroke-dasharray: 145 147;
        stroke-dashoffset: 146;
        animation: HNpDwPXc_draw 123ms ease-in-out 2443ms forwards;
    }

    .HNpDwPXc_9 {
        stroke-dasharray: 101 103;
        stroke-dashoffset: 102;
        animation: HNpDwPXc_draw 86ms ease-in-out 2566ms forwards;
    }

    .HNpDwPXc_10 {
        stroke-dasharray: 99 101;
        stroke-dashoffset: 100;
        animation: HNpDwPXc_draw 84ms ease-in-out 2652ms forwards;
    }

    .HNpDwPXc_11 {
        stroke-dasharray: 98 100;
        stroke-dashoffset: 99;
        animation: HNpDwPXc_draw 83ms ease-in-out 2736ms forwards;
    }

    .HNpDwPXc_12 {
        stroke-dasharray: 93 95;
        stroke-dashoffset: 94;
        animation: HNpDwPXc_draw 79ms ease-in-out 2820ms forwards;
    }

    .HNpDwPXc_13 {
        stroke-dasharray: 3 5;
        stroke-dashoffset: 4;
        animation: HNpDwPXc_draw 3ms ease-in-out 2899ms forwards;
    }

    .HNpDwPXc_14 {
        stroke-dasharray: 3 5;
        stroke-dashoffset: 4;
        animation: HNpDwPXc_draw 3ms ease-in-out 2902ms forwards;
    }

    .HNpDwPXc_15 {
        stroke-dasharray: 3 5;
        stroke-dashoffset: 4;
        animation: HNpDwPXc_draw 3ms ease-in-out 2906ms forwards;
    }

    .HNpDwPXc_16 {
        stroke-dasharray: 101 103;
        stroke-dashoffset: 102;
        animation: HNpDwPXc_draw 86ms ease-in-out 2909ms forwards;
    }

    .HNpDwPXc_17 {
        stroke-dasharray: 4 6;
        stroke-dashoffset: 5;
        animation: HNpDwPXc_draw 4ms ease-in-out 2995ms forwards;
    }

    @keyframes HNpDwPXc_draw {
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes HNpDwPXc_fade {
        0% {
            stroke-opacity: 1;
        }

        94.44444444444444% {
            stroke-opacity: 1;
        }

        100% {
            stroke-opacity: 0;
        }
    }
</style>
</svg>
<style>
/***************************************************
* Generated by SVG Artista on 11/16/2022, 9:52:09 PM
* MIT license (https://opensource.org/licenses/MIT)
* W. https://svgartista.net
**************************************************/

@-webkit-keyframes animate-svg-fill-1 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

@keyframes animate-svg-fill-1 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

.svg-elem-1 {
-webkit-animation: animate-svg-fill-1 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.35s both;
animation: animate-svg-fill-1 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.35s both;
}

@-webkit-keyframes animate-svg-fill-2 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

@keyframes animate-svg-fill-2 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

.svg-elem-2 {
-webkit-animation: animate-svg-fill-2 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.55s both;
animation: animate-svg-fill-2 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.55s both;
}

@-webkit-keyframes animate-svg-fill-3 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

@keyframes animate-svg-fill-3 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

.svg-elem-3 {
-webkit-animation: animate-svg-fill-3 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.75s both;
animation: animate-svg-fill-3 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.75s both;
}

@-webkit-keyframes animate-svg-fill-4 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

@keyframes animate-svg-fill-4 {
0% {
fill: transparent;
}

100% {
fill: rgb(255, 255, 255);
}
}

.svg-elem-4 {
-webkit-animation: animate-svg-fill-4 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.9500000000000001s both;
animation: animate-svg-fill-4 0.6s cubic-bezier(0.86, 0, 0.07, 1) 0.9500000000000001s both;
}

@-webkit-keyframes animate-svg-fill-5 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-5 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-5 {
-webkit-animation: animate-svg-fill-5 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.15s both;
animation: animate-svg-fill-5 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.15s both;
}

@-webkit-keyframes animate-svg-fill-6 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-6 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-6 {
-webkit-animation: animate-svg-fill-6 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.35s both;
animation: animate-svg-fill-6 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.35s both;
}

@-webkit-keyframes animate-svg-fill-7 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-7 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-7 {
-webkit-animation: animate-svg-fill-7 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.5500000000000003s both;
animation: animate-svg-fill-7 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.5500000000000003s both;
}

@-webkit-keyframes animate-svg-fill-8 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-8 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-8 {
-webkit-animation: animate-svg-fill-8 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.75s both;
animation: animate-svg-fill-8 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.75s both;
}

@-webkit-keyframes animate-svg-fill-9 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-9 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-9 {
-webkit-animation: animate-svg-fill-9 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.9500000000000002s both;
animation: animate-svg-fill-9 0.6s cubic-bezier(0.86, 0, 0.07, 1) 1.9500000000000002s both;
}

@-webkit-keyframes animate-svg-fill-10 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-10 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-10 {
-webkit-animation: animate-svg-fill-10 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.15s both;
animation: animate-svg-fill-10 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.15s both;
}

@-webkit-keyframes animate-svg-fill-11 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-11 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-11 {
-webkit-animation: animate-svg-fill-11 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.35s both;
animation: animate-svg-fill-11 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.35s both;
}

@-webkit-keyframes animate-svg-fill-12 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-12 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-12 {
-webkit-animation: animate-svg-fill-12 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.5500000000000003s both;
animation: animate-svg-fill-12 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.5500000000000003s both;
}

@-webkit-keyframes animate-svg-fill-13 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-13 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-13 {
-webkit-animation: animate-svg-fill-13 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.7500000000000004s both;
animation: animate-svg-fill-13 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.7500000000000004s both;
}

@-webkit-keyframes animate-svg-fill-14 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-14 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-14 {
-webkit-animation: animate-svg-fill-14 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.95s both;
animation: animate-svg-fill-14 0.6s cubic-bezier(0.86, 0, 0.07, 1) 2.95s both;
}

@-webkit-keyframes animate-svg-fill-15 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-15 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-15 {
-webkit-animation: animate-svg-fill-15 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.1500000000000004s both;
animation: animate-svg-fill-15 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.1500000000000004s both;
}

@-webkit-keyframes animate-svg-fill-16 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-16 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-16 {
-webkit-animation: animate-svg-fill-16 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.35s both;
animation: animate-svg-fill-16 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.35s both;
}

@-webkit-keyframes animate-svg-fill-17 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-17 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-17 {
-webkit-animation: animate-svg-fill-17 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.5500000000000003s both;
animation: animate-svg-fill-17 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.5500000000000003s both;
}

@-webkit-keyframes animate-svg-fill-18 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

@keyframes animate-svg-fill-18 {
0% {
fill: transparent;
}

100% {
fill: rgb(0, 113, 186);
}
}

.svg-elem-18 {
-webkit-animation: animate-svg-fill-18 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.7500000000000004s both;
animation: animate-svg-fill-18 0.6s cubic-bezier(0.86, 0, 0.07, 1) 3.7500000000000004s both;
}
</style>`;
var logo2NoAnimate = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
y="0px" width="500px" viewBox="0 0 325 120" enable-background="new 0 0 325 120" xml:space="preserve" style=""
height="200px">
<path fill="#fff" opacity="1.000000" stroke="none" d="
M87.000000,1.000000 
C90.361290,1.000000 93.722572,1.000000 97.541931,1.468657 
C98.000000,41.624878 98.000000,81.312439 98.000000,121.000000 
C74.312439,121.000000 50.624878,121.000000 26.468658,120.531342 
C26.000000,80.375122 26.000000,40.687561 26.000000,1.000000 
C37.354229,1.000000 48.708454,1.000000 60.531342,1.468654 
C61.000000,9.858344 61.000000,17.779381 61.000000,25.688736 
C69.969002,25.688736 78.351570,25.688736 87.000000,25.688736 
C87.000000,17.252964 87.000000,9.126482 87.000000,1.000000 
M66.612335,74.000000 
C73.343552,74.000000 80.074760,74.000000 86.655792,74.000000 
C86.655792,65.273834 86.655792,57.234253 86.655792,49.345581 
C77.935875,49.345581 69.563774,49.345581 61.172234,49.345581 
C61.172234,57.611473 61.172234,65.530579 61.172234,73.771645 
C62.762066,73.852905 64.200996,73.926453 66.612335,74.000000 
z"></path>

<path fill="#FFFFFF" opacity="1.000000" stroke="none" d="
M231.000000,1.000000 
C234.361282,1.000000 237.722580,1.000000 241.541931,1.468657 
C242.000000,41.624878 242.000000,81.312439 242.000000,121.000000 
C230.645767,121.000000 219.291550,121.000000 207.364761,120.648254 
C206.410461,119.584373 205.957794,118.900864 205.657318,118.155952 
C196.157593,94.605423 186.616653,71.071281 177.205353,47.485420 
C171.038177,32.029678 165.061813,16.497789 159.000000,1.000002 
C174.354233,1.000000 189.708450,1.000000 205.531342,1.468654 
C206.000000,9.858178 206.000000,17.779049 206.000000,25.688488 
C214.635757,25.688488 222.685425,25.688488 231.000000,25.688488 
C231.000000,17.253065 231.000000,9.126533 231.000000,1.000000 
z"></path>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" d="
M326.000000,74.000000 
C326.000000,81.354256 326.000000,88.708504 325.750061,96.542511 
C325.340393,97.070381 325.180664,97.118515 324.556030,97.094299 
C317.061066,97.070099 310.030975,97.118248 302.690613,97.173927 
C302.572693,97.825562 302.765106,98.469666 302.976013,99.574142 
C302.718536,106.695419 302.442596,113.356323 302.094482,120.257751 
C302.014862,120.665504 302.007416,120.832748 302.000000,121.000000 
C290.645782,121.000000 279.291534,121.000000 267.468658,120.531342 
C267.000000,80.375122 267.000000,40.687561 267.000000,1.000000 
C278.354218,1.000000 289.708466,1.000000 301.531342,1.468654 
C302.000000,9.864621 302.000000,17.791935 302.000000,26.000000 
C310.399811,26.000000 318.199890,26.000000 326.000000,26.000000 
C326.000000,33.354252 326.000000,40.708500 325.531342,48.531376 
C309.479584,49.000000 293.896454,49.000000 278.315033,49.000000 
C278.315033,57.633320 278.315033,65.687744 278.315033,74.000000 
C294.419098,74.000000 310.209534,74.000000 326.000000,74.000000 
z"></path>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" d="
M123.000000,1.000000 
C126.361290,1.000000 129.722580,1.000000 133.542511,1.391032 
C134.009521,2.115044 133.923462,2.485865 134.039612,2.775631 
C144.462311,28.775736 154.946487,54.751308 165.318741,80.771500 
C170.647842,94.140327 175.779251,107.587975 181.000000,121.000000 
C161.979111,121.000000 142.958206,121.000000 123.468658,120.531342 
C123.000000,80.375122 123.000000,40.687561 123.000000,1.000000 
z"></path>
<defs>   
<clipPath id="textV1" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M181.468643,121.000000 
C175.779251,107.587975 170.647842,94.140327 165.318741,80.771500 
C154.946487,54.751308 144.462311,28.775736 134.039612,2.775631 
C133.923462,2.485865 134.009521,2.115044 134.000580,1.391032 
C142.020905,1.000000 150.041809,1.000000 158.531342,1.000002 
C165.061813,16.497789 171.038177,32.029678 177.205353,47.485420 
C186.616653,71.071281 196.157593,94.605423 205.657318,118.155952 
C205.957794,118.900864 206.410461,119.584373 206.896103,120.648254 
C198.645767,121.000000 190.291534,121.000000 181.468643,121.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textV1}" width="100%" clip-path="url(#textV1)"></image>

<defs>   
<clipPath id="textF1" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M25.531321,1.000000 
C26.000000,40.687561 26.000000,80.375122 26.000000,120.531342 
C17.688169,121.000000 9.376340,121.000000 1.063393,120.999985 
C1.062276,80.999962 1.062276,40.999950 1.062276,1.000000 
C9.103914,1.000000 17.083279,1.000000 25.531321,1.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textF1}" width="100%" clip-path="url(#textF1)"></image>

  <defs>   
<clipPath id="textE1" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M266.531372,1.000000 
C267.000000,40.687561 267.000000,80.375122 267.000000,120.531342 
C258.979095,121.000000 250.958191,121.000000 242.468643,121.000000 
C242.000000,81.312439 242.000000,41.624878 242.000000,1.468657 
C250.020905,1.000000 258.041809,1.000000 266.531372,1.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textE1}" width="100%" clip-path="url(#textE1)"></image>

<defs>   
<clipPath id="textI" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M122.531349,1.000000 
C123.000000,40.687561 123.000000,80.375122 123.000000,120.531342 
C114.979103,121.000000 106.958199,121.000000 98.468651,121.000000 
C98.000000,81.312439 98.000000,41.624878 98.000000,1.468657 
C106.020897,1.000000 114.041801,1.000000 122.531349,1.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textI}" width="100%" clip-path="url(#textI)"></image>

  <defs>   
<clipPath id="textE3" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M326.000000,73.531349 
C310.209534,74.000000 294.419098,74.000000 278.315033,74.000000 
C278.315033,65.687744 278.315033,57.633320 278.315033,49.000000 
C293.896454,49.000000 309.479584,49.000000 325.531342,49.000000 
C326.000000,57.020901 326.000000,65.041801 326.000000,73.531349 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textE3}" width="100%" clip-path="url(#textE3)"></image>

<defs>   
<clipPath id="textF2" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M86.531349,1.000000 
C87.000000,9.126482 87.000000,17.252964 87.000000,25.688736 
C78.351570,25.688736 69.969002,25.688736 61.000000,25.688736 
C61.000000,17.779381 61.000000,9.858344 61.000000,1.468654 
C69.354233,1.000000 77.708466,1.000000 86.531349,1.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textF2}" width="100%" clip-path="url(#textF2)"></image>

  <defs>   
<clipPath id="textV2" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M230.531357,1.000000 
C231.000000,9.126533 231.000000,17.253065 231.000000,25.688488 
C222.685425,25.688488 214.635757,25.688488 206.000000,25.688488 
C206.000000,17.779049 206.000000,9.858178 206.000000,1.468654 
C214.020905,1.000000 222.041809,1.000000 230.531357,1.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textV2}" width="100%" clip-path="url(#textV2)"></image>

  <defs>   
  <clipPath id="textE2" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M326.000000,25.531321 
C318.199890,26.000000 310.399811,26.000000 302.000000,26.000000 
C302.000000,17.791935 302.000000,9.864621 302.000000,1.468654 
C309.927856,1.000000 317.855713,1.000000 326.000000,1.000000 
C326.000000,9.019587 326.000000,17.041115 326.000000,25.531321 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textE2}" width="100%" clip-path="url(#textE2)"></image>

  <defs>   
  <clipPath id="textE4" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M303.000916,97.166397 
C310.030975,97.118248 317.061066,97.070099 324.671448,97.283447 
C325.454346,97.773598 325.703766,97.925285 326.000000,98.000000 
C326.000000,105.020950 326.000000,112.041893 325.780640,119.639328 
C325.287628,120.415283 325.100555,120.676674 325.000000,121.000000 
C317.979034,121.000000 310.958099,121.000000 303.383423,120.794968 
C302.670258,120.327766 302.449219,120.136864 302.166626,120.017227 
C302.442596,113.356323 302.718536,106.695419 302.990875,99.249649 
C302.991821,98.031990 302.996368,97.599190 303.000916,97.166397 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textE4}" width="100%" clip-path="url(#textE4)"></image>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M326.000000,97.750000 
C325.703766,97.925285 325.454346,97.773598 325.136353,97.355804 
C325.180664,97.118515 325.340393,97.070381 325.750061,97.011124 
C326.000000,97.000000 326.000000,97.500000 326.000000,97.750000 
z"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M302.094452,120.257751 
C302.449219,120.136864 302.670258,120.327766 302.914856,120.794968 
C303.000000,121.000000 302.500000,121.000000 302.250000,121.000000 
C302.007416,120.832748 302.014862,120.665504 302.094452,120.257751 
z"></path>
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M325.500000,121.000000 
C325.100555,120.676674 325.287628,120.415283 325.780640,120.107910 
C326.000000,120.333336 326.000000,120.666664 325.500000,121.000000 
z"></path>

<defs>   
<clipPath id="textF3" >
<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M66.126129,74.000000 
C64.200996,73.926453 62.762066,73.852905 61.172234,73.771645 
C61.172234,65.530579 61.172234,57.611473 61.172234,49.345581 
C69.563774,49.345581 77.935875,49.345581 86.655792,49.345581 
C86.655792,57.234253 86.655792,65.273834 86.655792,74.000000 
C80.074760,74.000000 73.343552,74.000000 66.126129,74.000000 
z"></path>
</clipPath> 
  </defs> 
  <image xlink:href="${urlImage.textF3}" width="100%" clip-path="url(#textF3)"></image>

<path fill="#0071BA" opacity="1.000000" stroke="none" d="
M302.690613,97.173927 
C302.996368,97.599190 302.991821,98.031990 302.972412,98.789276 
C302.765106,98.469666 302.572693,97.825562 302.690613,97.173927 
z"></path>`;
//TODO: replace image logo url here

export default Projects1;
